import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChartModule } from 'angular2-highcharts';
import { HighchartsStatic } from 'angular2-highcharts/dist/HighchartsService';

import * as Highcharts from 'highcharts';
require('highcharts/highcharts-more.js')(Highcharts);

import { HChartComponent } from './hchart.component';
import { HChartRestComponent } from './hchart-rest.component';

declare var require: any;
export function highchartsFactory() {
    let highcharts = require('highcharts');
    let highchartsMore = require('highcharts/highcharts-more');
    let exporting = require('highcharts/modules/exporting');
    let drilldown = require('highcharts/modules/drilldown');
    let solidgauge = require('highcharts/modules/solid-gauge');
    highchartsMore(highcharts);
    exporting(highcharts);
    drilldown(highcharts);
    solidgauge(highcharts);
    return highcharts;
}

@NgModule({
    imports: [
        CommonModule,
        ChartModule
    ],
    exports: [
        HChartComponent,
        HChartRestComponent
    ],
    declarations: [
        HChartComponent,
        HChartRestComponent
    ],
    providers: [
        {
            provide: HighchartsStatic,
            useFactory: highchartsFactory
        }
    ]
})

export class HChartModule { }